import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useConfirmBookingPresence } from 'src/features/bookings/api/hooks/use-confirm-booking-presence';

interface Props extends DialogActions {
  bookingToken: string;
  spaceToken: string;
}

export const ConfirmBookingPresenceDialog = ({
  open,
  onCancel,
  bookingToken,
  spaceToken,
}: Props) => {
  const { t } = useTranslation(['bookings', 'common']);

  const {
    mutate: confirmBookingPresence,
    isPending: isConfirmingBookingPresence,
  } = useConfirmBookingPresence(onCancel);

  const handleConfirmBookingPresence = () => {
    confirmBookingPresence({ bookingToken, spaceToken });
  };

  return (
    <Dialog
      variant="warning"
      open={open}
      onCancel={onCancel}
      onConfirm={handleConfirmBookingPresence}
      confirmButtonText={t(
        'bookings:common.confirmPresenceDialog.confirmButtonText',
      )}
      cancelButtonText={t('common:button.no')}
      isConfirmButtonSubmitting={isConfirmingBookingPresence}
      title={t('bookings:common.confirmPresenceDialog.title')}>
      <Typography variant="body2">
        {t('bookings:common.confirmPresenceDialog.message')}
      </Typography>
    </Dialog>
  );
};
